module.exports = __webpack_public_path__ + "img/desc_bottom_blshj02.9842e9f2.png";